import React, { useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch } from "react-redux";
//component
import LayoutHeader from "../00_Nav/layout/layout_header";
import HistoryHeader from "./component/history_header";
import RequestHeader from "./component/request_header";
import RequestTable from "./component/request_table";
import HistoryTable from "./component/history_table";
import HistoryWallet from "./component/history_wallet";
import HistoryTab from "./component/history_tab";
import TriggerInit from "./trigger/trigger_init";
//action
import { setHighlight } from "../../store/bailiff/nav/nav.action";
import { useSearchParams } from "react-router-dom";
import DialogWithdraw from "./dialog/dialog_withdraw";
import "./style.css";
import HistoryTableClone from "./component/history_table_clone";
import HistoryHeaderClone from "./component/history_header_clone";

const { Content } = Layout;

const HistoryScreen = () => {
  // -------------------------- VAR --------------------------
  const title = "Ví cá nhân";
  const [searchParams] = useSearchParams();
  const tab = searchParams?.get("tab") || "history";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["2"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------
  const renderWallet = () => {
    return (
      <div
        style={{
          minHeight: 100,
          width: "100%",
          background: "#fff",
          borderRadius: 10,
          boxShadow: "1px 1px 10px 1px rgba(182, 182, 182, 0.2)",
        }}
      >
        <HistoryWallet />
      </div>
    );
  };

  const renderTab = () => {
    return <HistoryTab />;
  };

  const renderPayment = () => {
    if (tab !== "history") return null;
    return (
      <div
        style={{
          minHeight: 100,
          width: "100%",
          background: "#fff",
          borderRadius: 10,
          boxShadow: "1px 1px 10px 1px rgba(182, 182, 182, 0.2)",
        }}
      >
        <Row gutter={[10, 10]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <HistoryHeaderClone />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <HistoryTableClone />
          </Col>
        </Row>
      </div>
    );
  };

  const renderRequest = () => {
    if (tab !== "request") return null;
    return (
      <div
        style={{
          minHeight: 100,
          width: "100%",
          background: "#fff",
          borderRadius: 10,
          boxShadow: "1px 1px 10px 1px rgba(182, 182, 182, 0.2)",
        }}
      >
        <Row gutter={[10, 10]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <RequestHeader />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <RequestTable />
          </Col>
        </Row>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row justify={"center"} gutter={[0, 30]}>
          <Col
            style={{
              marginTop: 20,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
            xl={14}
            lg={14}
            md={22}
            xs={24}
          >
            {renderWallet()}
            {renderTab()}
            {renderPayment()}
            {renderRequest()}
          </Col>
        </Row>
        <DialogWithdraw />
        <TriggerInit />
      </Content>
    </Layout>
  );
};

export default HistoryScreen;
